import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbaniaonrentinnavimumbai() {



const cardData = {
  keyword: "  Force Urbania on Rent in Navi Mumbai ",

headingDescription: "Velocity Cab offers Force Urbania on rent in Navi Mumbai, providing a rugged, spacious, and comfortable SUV option ideal for family outings, group trips, off‑road adventures, corporate travel, and long‑distance journeys. Our well‑maintained Force Urbania vehicles deliver powerful performance, ample seating, and generous luggage space to handle both city roads and nearby hill or rural routes with ease. Whether you need an hourly rental, full‑day use, airport transfers, or outstation travel, Velocity Cab offers flexible booking options with transparent pricing and no hidden charges. With professional drivers, prompt service, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for renting Force Urbania in Navi Mumbai.",

topPlaces: [
  
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a revered pilgrimage destination famous for one of the twelve Jyotirlingas of Lord Shiva. Visitors can seek blessings at the ancient temple while enjoying the scenic surroundings of the Brahmagiri Hills."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a renowned pilgrimage site and wildlife sanctuary nestled in the Sahyadri Hills. It is known for its Jyotirlinga Temple, dense forests, and trekking opportunities, making it perfect for spiritual and nature enthusiasts."
  },
  {
    title: "Chiplun",
    description: "Chiplun is a picturesque town in the Konkan region surrounded by rivers, hills, and lush greenery. Travelers can visit the famous Parshuram Temple and enjoy the region's natural beauty and peaceful atmosphere."
  },
  {
    title: "Karjat",
    description: "Karjat is a scenic destination near Mumbai known for its lush greenery, rivers, trekking trails, and peaceful resorts. Travelers booking a sedan cab can enjoy a relaxing drive while exploring waterfalls, ancient caves, and beautiful countryside landscapes."
  },
  {
    title: "Kamshet",
    description: "Kamshet is a popular adventure destination famous for paragliding, rolling hills, and picturesque lakes. Visitors can experience thrilling flights, nature walks, and breathtaking views of the Western Ghats."
  },
  {
    title: "Daman",
    description: "Daman is a coastal town known for its tranquil beaches, Portuguese architecture, and historic forts. Travelers can explore Devka Beach, Jampore Beach, and colonial-era churches while enjoying a peaceful seaside getaway."
  },
  {
    title: "Silvassa",
    description: "Silvassa is the capital of Dadra and Nagar Haveli, offering lush gardens, wildlife attractions, museums, and tribal culture. It is an ideal destination for nature lovers and families seeking a refreshing vacation."
  },
  {
    title: "Velas",
    description: "Velas is a charming coastal village famous for its Olive Ridley Turtle Festival and pristine beaches. Nature lovers can witness turtle conservation efforts and enjoy an eco-friendly getaway."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a breathtaking mountain pass known for waterfalls, misty valleys, and rich biodiversity. It is a favorite destination for monsoon road trips, birdwatching, and scenic photography."
  },
  {
    title: "Ratnagiri",
    description: "Ratnagiri is a beautiful coastal city known for its beaches, historic forts, Alphonso mango orchards, and cultural heritage. Visitors can explore Ratnadurg Fort, Ganeshgule Beach, and enjoy the region's scenic Konkan coastline."
  }
],



services: [
{
name: "Force Urbania on Rent Navi Mumbai",
description: "Force Urbania on rent in Navi Mumbai offers a premium travel experience for group journeys with spacious seating, modern interiors, and advanced comfort features. This luxury van is ideal for family trips, corporate travel, airport transfers, and outstation tours from Navi Mumbai. Designed with comfortable pushback seats, ample legroom, and excellent suspension, Urbania ensures a smooth and relaxing ride even on long routes. Professional drivers with experience in highway and city travel guarantee safety and timely service. Customers can choose flexible rental options including hourly, daily, or outstation packages based on their needs. Pickup is available from all major locations including Vashi, Kharghar, Belapur, and Panvel. With transparent pricing and easy booking, this service provides a perfect blend of luxury, comfort, and convenience."
},
{
name: "Urbania Van Rental Navi Mumbai",
description: "Urbania van rental Navi Mumbai provides a modern and comfortable group travel solution with spacious seating and premium features. This service is ideal for families, tourists, and corporate teams looking for reliable transportation. The vehicle offers smooth performance on highways and city roads, ensuring a pleasant journey experience. Professional drivers ensure safe and efficient travel across all routes. Flexible booking options allow customers to plan trips as per their convenience. It is one of the best choices for group travel in Navi Mumbai."
},
{
name: "Luxury Force Urbania Hire Navi Mumbai",
description: "Luxury Force Urbania hire Navi Mumbai offers a high-end travel experience with premium interiors, comfortable seating, and advanced features. This service is perfect for corporate events, VIP travel, weddings, and luxury tours. The vehicle ensures a smooth and stylish journey for passengers. Professional chauffeurs provide safe and punctual service. Flexible rental packages are available for different travel needs. It guarantees a premium and comfortable ride experience."
},
{
name: "17 Seater Force Urbania on Rent Navi Mumbai",
description: "17 seater Force Urbania on rent Navi Mumbai is ideal for large groups such as family tours, corporate outings, and group travel. The vehicle offers spacious seating, comfortable interiors, and excellent luggage capacity. It ensures a smooth journey for long-distance trips and city travel. Professional drivers ensure safe driving and timely service. This option is perfect for group travel with comfort and convenience. It is widely preferred for outstation trips."
},
{
name: "13 Seater Urbania Van Rental Navi Mumbai",
description: "13 seater Urbania van rental Navi Mumbai is perfect for medium-sized groups seeking comfortable and spacious travel. The vehicle offers modern interiors, comfortable seating, and smooth ride quality. It is ideal for family trips, business travel, and small group tours. Professional drivers ensure safe and reliable service. Flexible booking options make it convenient for customers. It provides a balanced combination of comfort and affordability."
},
{
name: "Urbania Tempo Traveller Navi Mumbai",
description: "Urbania tempo traveller Navi Mumbai provides a modern alternative to traditional tempo travellers with better comfort and advanced features. This vehicle is suitable for group tours, school trips, and corporate travel. Spacious interiors and smooth suspension ensure a comfortable journey. Experienced drivers handle long-distance and city routes efficiently. Flexible travel plans allow customization based on needs. It ensures a premium group travel experience."
},
{
name: "Cheap Force Urbania on Rent Navi Mumbai",
description: "Cheap Force Urbania on rent Navi Mumbai offers budget-friendly options for group travel without compromising on comfort and safety. This service is ideal for cost-conscious travelers who want premium travel at affordable rates. Well-maintained vehicles and professional drivers ensure a smooth journey. Transparent pricing ensures no hidden charges. Flexible rental plans are available for different needs. It is a perfect choice for affordable luxury travel."
},
{
name: "Force Urbania for Outstation Navi Mumbai",
description: "Force Urbania for outstation Navi Mumbai provides long-distance travel solutions with comfort and reliability. This service is ideal for tours to destinations like Pune, Lonavala, Mahabaleshwar, and Goa. Spacious seating and smooth ride quality make long journeys relaxing. Professional drivers ensure safe driving on highways and ghat roads. Flexible packages allow one way and round trip options. It ensures a comfortable and stress-free travel experience."
},
{
name: "Urbania Van for Wedding Navi Mumbai",
description: "Urbania van for wedding Navi Mumbai offers stylish and comfortable transportation for wedding events, guest transfers, and family travel. The vehicle provides premium interiors and spacious seating for guests. It ensures timely and smooth transportation between venues. Professional drivers maintain punctuality and safety during events. Flexible booking options are available for hourly and full-day rentals. It is a perfect choice for luxury wedding travel."
},
{
name: "Urbania Airport Pickup Navi Mumbai",
description: "Urbania airport pickup Navi Mumbai provides reliable and comfortable airport transfer services for groups and families. This service ensures timely pickup and drop at Mumbai Airport with spacious seating and luggage capacity. Professional drivers track flight timings for smooth coordination. It is ideal for group airport transfers with comfort and convenience. Flexible booking options are available. It ensures a hassle-free airport travel experience."
},
{
name: "Force Urbania with Driver Navi Mumbai",
description: "Force Urbania with driver Navi Mumbai offers a complete travel solution with professional chauffeurs ensuring safe and comfortable journeys. This service is ideal for both city travel and outstation trips. Drivers are experienced, well-trained, and familiar with routes for smooth navigation. Customers can enjoy a relaxed journey without worrying about driving. Flexible rental plans are available based on travel needs. It ensures a premium and stress-free travel experience."
}
],

tableData: [
["Force Urbania on Rent Navi Mumbai","Urbania Van Rental Navi Mumbai"],
["Luxury Force Urbania Hire Navi Mumbai","17 Seater Force Urbania on Rent Navi Mumbai"],
["13 Seater Urbania Van Rental Navi Mumbai","Urbania Tempo Traveller Navi Mumbai"],
["Cheap Force Urbania on Rent Navi Mumbai","Force Urbania for Outstation Navi Mumbai"],
["Urbania Van for Wedding Navi Mumbai","Urbania Airport Pickup Navi Mumbai"],
["Force Urbania with Driver Navi Mumbai","Urbania Van Rental Navi Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Premium Group Travel Experience",
    WhyChoosedescription: "Velocity Cabs offers Force Urbania on rent in Navi Mumbai with luxury interiors, spacious seating, and modern amenities, making it perfect for group tours, corporate travel, weddings, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Travel",
    WhyChoosedescription: "Our drivers are highly experienced in Navi Mumbai city routes, Mumbai highways, and outstation travel, ensuring safe driving and smooth journeys for all passengers."
  },
  {
    WhyChooseheading: "Transparent & Affordable Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Force Urbania rental in Navi Mumbai. Customers receive complete fare details including per km charges, tolls, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Urbania Rental Availability",
    WhyChoosedescription: "Our Force Urbania rental service operates 24/7, allowing customers to book vehicles anytime for airport transfers, outstation trips, corporate events, and family travel."
  },
  {
    WhyChooseheading: "Spacious & Fully AC Vehicles",
    WhyChoosedescription: "Force Urbania vehicles come with powerful air-conditioning, pushback seats, wide windows, and ample legroom, ensuring a comfortable journey for every passenger." 
  },
  {
    WhyChooseheading: "Multiple Seating Options",
    WhyChoosedescription: "Velocity Cabs offers multiple seating options including 10, 13, 15, and 17-seater Force Urbania vehicles, suitable for small and large groups." 
  },
  {
    WhyChooseheading: "Ideal for Corporate & Group Travel",
    WhyChoosedescription: "Force Urbania is ideal for corporate outings, airport transfers, family trips, school tours, and wedding events, offering luxury and convenience in one vehicle." 
  },
  {
    WhyChooseheading: "Trusted Urbania Rental Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Force Urbania on rent in Navi Mumbai due to professional drivers, well-maintained vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide Force Urbania on rent in Navi Mumbai?", answer: "Yes, Velocity Cabs provides Force Urbania rental services in Navi Mumbai for local and outstation group travel." },
  { question: "What is the price of Force Urbania on rent in Navi Mumbai?", answer: "The rental cost typically starts from around ₹30 to ₹35 per km for outstation trips depending on seating capacity and requirements." },
  { question: "How many passengers can travel in Force Urbania?", answer: "Force Urbania is available in multiple seating options ranging from 10-seater to 17-seater suitable for group travel." },
  { question: "Is Force Urbania available for outstation trips?", answer: "Yes, Force Urbania is ideal for outstation travel from Navi Mumbai to destinations like Pune, Lonavala, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Can I book Urbania for weddings or events?", answer: "Yes, Force Urbania is perfect for weddings, corporate events, and group outings with luxury seating and spacious interiors." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our Force Urbania rental service in Navi Mumbai operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Force Urbania vehicles are fully air-conditioned with individual vents for passenger comfort." },
  { question: "Can I book Force Urbania online?", answer: "Yes, customers can easily book Force Urbania on rent in Navi Mumbai online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all bookings include professional drivers for safe and comfortable travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Jadhav",
    feedback:
      "I rented a Force Urbania in Navi Mumbai from Velocity Cabs for a group trip, and the experience was excellent. The vehicle was spacious, clean, and very comfortable for long-distance travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Sawant",
    feedback:
      "The Force Urbania on rent in Navi Mumbai was perfect for our family outing. The seating was very comfortable, the vehicle was well-maintained, and the journey was smooth throughout.",
    rating: 5
  }
];



























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const forceUrbaniaNaviMumbaiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Force Urbania On Rent in Navi Mumbai | Velocity Cabs",
  "description": "Rent a Force Urbania van in Navi Mumbai for outstation trips, airport pickups, weddings, or group travel. 13-seater, 17-seater, and luxury options with driver available at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Force Urbania Rental Packages in Navi Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Force Urbania Rental",
        "description": "Rent a Force Urbania van for one-way travel in Navi Mumbai with 13-seater, 17-seater, and luxury options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Force Urbania Rental",
        "description": "Comfortable round-trip rental of Force Urbania vans in Navi Mumbai with private driver and various seating options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};






  return (
    <div>
      <Helmet>
  <title>Force Urbania On Rent in Navi Mumbai | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Rent a Force Urbania van in Navi Mumbai for outstation trips, airport pickups, weddings, or group travel. 13-seater, 17-seater, and luxury options with driver available at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(forceUrbaniaNaviMumbaiJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forceurbaniaonrentinnavimumbai;